import React from 'react';
import TagModal from './TagsTabbedModal';

export default {
  title: 'Components/Modals/TagModal',
  component: TagModal,
  argTypes: {
    handleClose: { action: 'handleClose' },
    onCreate: { action: 'onCreate' },
    isTagAsTabShowing: { control: 'boolean' },
    isCreateNewTabShowing: { control: 'boolean' },
    title: { control: 'text' },
  },
  tags: ['autodocs'],
};

// Default story
const Template = (args) => <TagModal {...args} />;

export const DefaultTagModal = Template.bind({});
DefaultTagModal.args = {
  title: 'Tag Modal',
  isTagAsTabShowing: true,
  isCreateNewTabShowing: true,
  isStorybook: true,
};

export const CreateNewTabOnly = Template.bind({});
CreateNewTabOnly.args = {
  title: 'Tag Modal',
  isTagAsTabShowing: false,
  isCreateNewTabShowing: true,
  isStorybook: true,
};

export const TabAsOnly = Template.bind({});
TabAsOnly.args = {
  title: 'Tag Modal',
  isTagAsTabShowing: true,
  isCreateNewTabShowing: false,
  isStorybook: true,
};
